import { Component, OnInit, OnDestroy, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Subscription, BehaviorSubject } from 'rxjs';
import DepartmentGroupService from 'src/app/shared/services/department-group.service';
import { DepartmentGroup } from '../../departmentGroup.model';
import { DepartmentGroupListComponent } from '../department-group-list/department-group-list.component';
import { DepartmentGroupInputComponent } from '../department-group-input/department-group-input.component';

@Component({
  selector: 'adm-department-group-add-or-edit',
  templateUrl: './department-group-add-or-edit.component.html',
  styleUrls: ['./department-group-add-or-edit.component.scss'],
  imports: [DepartmentGroupListComponent, DepartmentGroupInputComponent, MatDialogModule, MatButtonModule, MatIconModule],
})
export class DepartmentGroupAddOrEditComponent implements OnInit, OnDestroy {
  private departmentGroupService = inject(DepartmentGroupService);
  dialogRef = inject<MatDialogRef<DepartmentGroupAddOrEditComponent>>(MatDialogRef);
  data = inject<{
    organizationId: number;
  }>(MAT_DIALOG_DATA);

  departmentGroupToEdit: DepartmentGroup | null = null;
  editMode: boolean;
  isDirty = false;

  departmentGroups = signal<DepartmentGroup[]>([]);

  private subscription: Subscription;
  private update = new BehaviorSubject<boolean>(false);

  ngOnInit() {
    this.subscription = this.update.subscribe(() => {
      this.departmentGroupService.getDepartmentGroups(this.data.organizationId).subscribe(results => {
        this.departmentGroups.set(results.items);
      });
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onUpdateDepartmentGroup(departmentGroup: DepartmentGroup) {
    if (departmentGroup) {
      this.departmentGroupToEdit = departmentGroup;
      this.editMode = true;
    }
  }

  reload() {
    this.isDirty = true;
    this.update.next(true);
  }

  doneEditing() {
    this.update.next(true);
    this.isDirty = true;
    this.editMode = false;
    this.departmentGroupToEdit = null;
  }

  cancel() {
    this.dialogRef.close(this.isDirty);
  }
}
